"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICE_DECORATION = exports.PRICE_SIZE = exports.PRICE_LAYOUT = void 0;
exports.PRICE_LAYOUT = {
    COMPACT: "compact",
    DEFAULT: "default",
};
exports.PRICE_SIZE = {
    XS: "xs",
    S: "s",
    M: "m",
    M_L: "m_l",
    L: "l",
    XL: "xl",
    XXL: "xxl",
    XXXL: "xxxl",
};
exports.PRICE_DECORATION = {
    LINE_THROUGH: "line-through",
    UNDERLINE: "underline",
    NONE: "",
};
//# sourceMappingURL=enums.js.map